import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Repo from "../../Repository/Repo";

const initialState = {
  loading: false,
  error: "",
  fastCashes: [],
};

export const getFastCashes = createAsyncThunk(
  "fastCashes/fetchFastCashes",
  () => {
    return Repo.fastcash({
      request: {
        method: "getFastCash",
        data: {
          company_code: localStorage.getItem("companyCode"),
          date: "",
        },
      },
    })
      .then(({ data }) => data.response.data.fast_cashes)
      .catch((err) => console.log(err));
  }
);

export const fastCashSlice = createSlice({
  name: "fastCashes",
  initialState,

  reducers: {
    removeFastCash: (state, action) => {
      const { index } = action.payload;
      state.fastCashes.splice(index, 1);
    },
    fastCashAdded: (state, action) => {
      const { index, user } = action.payload;
      state.fastCashes.splice(index, 1, user);
    },
    fastCashAmount: (state, action) => {
      const { _id, amount } = action.payload;
      let found = state.fastCashes.find((item) => item._id == _id);
      found.totalAmount = parseInt(found.totalAmount) + parseInt(amount);
    },
    removeCurrentFastCash: (state, action) => {
      state.fastCashes.splice(0, 1);
    },
    removeFastCashAmount: (state, action) => {
      const { _id, amount } = action.payload;
      let found = state.fastCashes.find((item) => item._id == _id);
      found.totalAmount = parseInt(found.totalAmount) - parseInt(amount);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFastCashes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFastCashes.fulfilled, (state, action) => {
      state.loading = false;
      state.fastCashes = action.payload;
      state.error = "";
    });
    builder.addCase(getFastCashes.rejected, (state, action) => {
      state.loading = false;
      state.fastCashes = [];
      state.error = action.error.message;
    });
  },
});

export const {
  removeFastCash,
  fastCashAdded,
  fastCashAmount,
  removeCurrentFastCash,
  removeFastCashAmount,
} = fastCashSlice.actions;

export default fastCashSlice.reducer;
